import {
  X,
  Save,
  RotateCcw,
  Banknote,
  Calendar,
  ShieldAlert,
} from "lucide-react";
import { useCreateChargePriceMutation } from "../api/billingApi";
import ChargePriceForm from "../components/ChangePriceForm";

interface ChargePriceModalProps {
  defaultYear: number;
  onClose: () => void;
  onSuccess: () => void;
}

export default function ChargePriceModal({
  defaultYear,
  onClose,
  onSuccess,
}: ChargePriceModalProps) {
  const [create, { isLoading: isBusy }] = useCreateChargePriceMutation();

  return (
    <div className="fixed inset-0 z-[100] flex justify-end">
      <div
        className="absolute inset-0 bg-gray-900/60 backdrop-blur-sm animate-in fade-in duration-300"
        onClick={onClose}
      />

      <div className="relative w-full max-w-xl bg-white h-full shadow-2xl flex flex-col animate-in slide-in-from-right duration-500">
        {/* Header */}
        <div className="p-8 border-b border-gray-50 bg-gray-50/30">
          <div className="flex justify-between items-start">
            <div className="flex gap-5">
              <div className="w-12 h-12 rounded-xl bg-gray-900 flex items-center justify-center text-white shrink-0 shadow-lg">
                <Banknote className="w-6 h-6" />
              </div>
              <div>
                <div className="text-[10px] font-black text-indigo-500 uppercase tracking-[0.3em] mb-1">
                  Financial Definition
                </div>
                <h3 className="text-2xl font-black text-gray-900 uppercase tracking-tight">
                  Deploy Price Point
                </h3>
              </div>
            </div>
            <button
              onClick={onClose}
              className="p-3 bg-white border border-gray-100 rounded-2xl hover:bg-rose-50 hover:text-rose-600 transition-all"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>

        {/* Content - Wraps your existing form component */}
        <div className="flex-1 overflow-y-auto p-8">
          <div className="bg-indigo-50/50 border border-indigo-100 rounded-2xl p-6 mb-8 flex gap-4 items-center">
            <ShieldAlert className="w-5 h-5 text-indigo-400" />
            <p className="text-[10px] font-bold text-indigo-600 uppercase tracking-tight leading-relaxed">
              Price points are year-specific. Ensure the selected Charge Type
              and Category/Band combination is unique for the {defaultYear}{" "}
              cycle.
            </p>
          </div>

          <ChargePriceForm defaultYear={defaultYear} onDone={onSuccess} />
        </div>

        {/* Footer info */}
        <div className="p-8 border-t border-gray-50 bg-white">
          <p className="text-center text-[9px] font-bold text-gray-300 uppercase tracking-[0.3em]">
            Authorized Pricing Deployment Node
          </p>
        </div>
      </div>
    </div>
  );
}
